import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsViewComponent } from './contact-us-view/contact-us-view.component';
import {ContactUsRoutingModule} from './contact-us-routing.module';
import { BranchInfoComponent } from './branch-info/branch-info.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatButtonModule, MatFormFieldModule, MatInputModule, MatRadioModule, MatSelectModule} from '@angular/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ContentBackDropModule} from '../@contents/@common/back-drop/content-back-drop.module';
import { ThankYouComponent } from './thank-you/thank-you.component';

@NgModule({
  imports: [
    CommonModule,
    ContactUsRoutingModule,
    FlexLayoutModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatRadioModule,
    ReactiveFormsModule,
    FormsModule,
    ContentBackDropModule
  ],
  declarations: [ContactUsViewComponent, BranchInfoComponent, ContactFormComponent, ThankYouComponent]
})
export class ContactUsModule { }
